var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHouse1 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "circle",
    cx: 26,
    cy: 26,
    r: 26
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    },
    clipPath: "url(#clip0_1405_22011)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 22.3493L32.4272 12.8926L20.8574 22.3493V40H44V22.3493Z",
    fill: "#DF3030"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8574 22.3463H8V39.997H20.8574V22.3463Z",
    fill: "#FF3737"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 22.3493H20.8574L32.4272 12.8926H19.5728L8 22.3493Z",
    fill: "#7F8C8D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4286 27.3911H11.8566V31.1731H14.4286V27.3911Z",
    fill: "#8DD4FC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7513 31.4896H11.537V27.0776H14.7513V31.4896ZM12.1792 30.8597H14.1091V27.6955H12.1792V30.8597Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0008 27.3911H14.4287V31.1731H17.0008V27.3911Z",
    fill: "#8DD4FC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3234 31.4896H14.1091V27.0776H17.3234V31.4896ZM14.7513 30.8597H16.6812V27.6955H14.7513V30.8597Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0008 31.1731H14.4287V34.9552H17.0008V31.1731Z",
    fill: "#8DD4FC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3234 35.2716H14.1091V30.8597H17.3234V35.2716ZM14.7513 34.6418H16.6812V31.4895H14.7513V34.6418Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4286 31.1731H11.8566V34.9552H14.4286V31.1731Z",
    fill: "#8DD4FC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7513 35.2716H11.537V30.8597H14.7513V35.2716ZM12.1792 34.6418H14.1091V31.4895H12.1792V34.6418Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M27.286 27.3911H24.7139V31.1731H27.286V27.3911Z",
    fill: "#FFDE0F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6087 31.4896H24.3882V27.0776H27.6026L27.6087 31.4896ZM25.0366 30.8597H26.9664V27.6955H25.0366V30.8597Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8582 27.3911H27.2861V31.1731H29.8582V27.3911Z",
    fill: "#FFDE0F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1716 31.4896H26.9573V27.0776H30.1716V31.4896ZM27.5996 30.8597H29.5263V27.6955H27.5996V30.8597Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8582 31.1731H27.2861V34.9552H29.8582V31.1731Z",
    fill: "#FFDE0F"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1716 35.2716H26.9573V30.8597H30.1716V35.2716ZM27.5996 34.6418H29.5263V31.4895H27.5996V34.6418Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M27.286 31.1731H24.7139V34.9552H27.286V31.1731Z",
    fill: "#FFDE0F"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6087 35.2716H24.3882V30.8597H27.6026L27.6087 35.2716ZM25.0366 34.6418H26.9664V31.4895H25.0366V34.6418Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5713 27.3911H34.9992V31.1731H37.5713V27.3911Z",
    fill: "#8DD4FC"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8939 31.4896H34.6796V27.0776H37.8939V31.4896ZM35.3219 30.8597H37.2517V27.6955H35.3219V30.8597Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1434 27.3911H37.5714V31.1731H40.1434V27.3911Z",
    fill: "#8DD4FC"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M40.466 31.4896H37.2517V27.0776H40.466V31.4896ZM37.894 30.8597H39.8207V27.6955H37.894V30.8597Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1434 31.1731H37.5714V34.9552H40.1434V31.1731Z",
    fill: "#8DD4FC"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M40.466 35.2716H37.2517V30.8597H40.466V35.2716ZM37.894 34.6418H39.8207V31.4895H37.894V34.6418Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5713 31.1731H34.9992V34.9552H37.5713V31.1731Z",
    fill: "#8DD4FC"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8939 35.2716H34.6796V30.8597H37.8939V35.2716ZM35.3219 34.6418H37.2517V31.4895H35.3219V34.6418Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4271 24.2388C33.4929 24.2388 34.357 23.3915 34.357 22.3463C34.357 21.3011 33.4929 20.4537 32.4271 20.4537C31.3613 20.4537 30.4973 21.3011 30.4973 22.3463C30.4973 23.3915 31.3613 24.2388 32.4271 24.2388Z",
    fill: "#ECF0F1"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7842 16.0418L18.9276 19.194V11H22.7842V16.0418Z",
    fill: "#FF3737"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1405_22011"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 29,
    fill: "white",
    transform: "translate(8 11)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHouse1);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/house1.73621e3ce3cb50ec8a0b7b15fac8ff00.svg";